var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyjobcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1358 27.1737C14.7733 28.5284 16.6843 28.5725 17.3837 27.2487L28.4738 6.25673L32.776 14.5302C33.3551 15.644 34.8628 15.8479 35.717 14.928L41.6172 8.57396C42.2994 7.83923 42.2569 6.69055 41.5221 6.0083C40.7874 5.32606 39.6387 5.3686 38.9565 6.10333L34.809 10.5698L30.0972 1.50864C29.4217 0.209583 27.5653 0.203538 26.8813 1.49817L15.8724 22.3366L10.1594 10.1965C9.67694 9.17128 8.38357 8.83365 7.46156 9.49223L1.10754 14.0308C0.291665 14.6136 0.102693 15.7474 0.685463 16.5633C1.26823 17.3792 2.40206 17.5681 3.21794 16.9854L7.80087 13.7119L14.1358 27.1737Z",
    fill: "#0FCC7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyjobcard);
export default __webpack_public_path__ + "static/media/myjobcard.051125d967e6427b43f371699a370168.svg";
export { ForwardRef as ReactComponent };